var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#9D9D9C;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M691,550.7c0,0,0-2.3,0-3.7V253c0-3.8-0.9-7.6-2.7-11c-2.5-5.3-6.7-9.5-12-12L409.7,110.7 c-3.2-1.5-6.8-2.2-10.3-2.2s-7.1,0.8-10.3,2.2L122.3,230c-4.3,2.2-7.9,5.4-10.5,9.5c-2.6,4-4,8.7-4.2,13.5v294 c0.2,4.8,1.7,9.4,4.3,13.4c2.6,4,6.1,7.3,10.4,9.6L389,689.3c3.2,1.5,6.8,2.3,10.3,2.3c3.6,0,7.1-0.8,10.3-2.3L676.3,570 c3.9-1.8,7.2-4.5,9.8-7.8C688.7,558.8,690.3,554.8,691,550.7z M157.7,291.3l216.7,97.3V628l-216.7-97V291.3z M424.3,388.7L641,291.3 V531l-216.7,97V388.7z M400,160.7L605.7,253L400,345l-205.7-92L400,160.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxg);
export default __webpack_public_path__ + "static/media/boxg.1e58e80da3f3fc40331d27aed8c9f2ed.svg";
export { ForwardRef as ReactComponent };